
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';

interface ComingSoonTabProps {
  title: string;
  description: string;
  icon: LucideIcon;
}

const ComingSoonTab: React.FC<ComingSoonTabProps> = ({ title, description, icon: Icon }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-center py-8">
          <Icon className="mx-auto h-12 w-12 text-muted-foreground mb-4" />
          <h3 className="text-xl font-medium mb-2">Coming Soon</h3>
          <p className="text-muted-foreground">
            {title} will be available in a future update.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ComingSoonTab;
